import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: false,
  transactions: [],
  graphData: {},
  transactionDetails: null,
  merchantDetails: {},
  searchResults: null,
  searchResultsCount: 0,
  searching: false,
  searchError: false,
  exporting: false,
  exportResults: "",
};

const analyticSlice = createSlice({
  name: "analytics",
  initialState,
  reducers: {
    getWidgetAnalyticsList: (state) => {
      state.loading = true;
    },
    getWidgetAnalyticsListSuccess: (state, action) => {
      state.loading = false;
      state.transactions = action.payload;
    },
    getWidgetAnalyticsListError: (state, action) => {
      state.loading = false;
      state.transactions = null;
    },

    searchWidgetAnalytics: (state) => {
      state.searching = true;
    },
    searchWidgetAnalyticsError: (state) => {
      state.searching = false;
      state.searchError = true;
      state.searchResults = null;
    },

    searchWidgetAnalyticsSuccess: (state, action) => {
      state.searching = false;
      state.searchError = false;
      state.searchResults = action.payload?.data;
      state.searchResultsCount = action.payload?.count;
    },

    emptyWidgetAnalyticsList: (state) => {
      state.searchResults = [];
      state.searchResultsCount = 0;
    },

    exportAccountWidgetAnalytics: (state) => {
      state.exporting = true;
      state.exportResults = "";
    },
    exportAccountWidgetAnalyticsSuccess: (state, action) => {
      state.exporting = false;
      state.exportResults = action.payload;
    },
    exportAccountWidgetAnalyticsError: (state, action) => {
      state.exporting = false;
      state.exportResults = "";
    },
    resetExportAccountWidgetAnalytics: (state) => {
      state.exporting = false;
      state.exportResults = "";
    },
    resetSearchState: (state) => {
      state.searching = false;
      state.searchError = false;
      state.searchResults = null;
    },

    getWidgetAnalyticsDetails: (state) => {
      state.loading = true;
    },
    getWidgetAnalyticsDetailsSuccess: (state, action) => {
      state.loading = false;
      state.merchantDetails = action.payload.data;
    },
    getWidgetAnalyticsDetailsError: (state, action) => {
      state.loading = false;
      state.merchantDetails = {};
    },

    getWidgetAnalyticsTransactions: (state) => {
      state.loading = true;
    },
    searchWidgetAnalyticsTransactions: (state) => {
      state.loading = true;
    },
    getWidgetAnalyticsTransactionsSuccess: (state, action) => {
      state.loading = false;
      state.transactions = action.payload;
    },
    getWidgetAnalyticsTransactionsError: (state, action) => {
      state.loading = false;
      state.transactions = null;
    },

    getWidgetAnalyticsTransactionsGraphData: (state) => {
      state.loading = true;
    },
    getWidgetAnalyticsTransactionsGraphDataSuccess: (state, action) => {
      state.loading = false;
      state.graphData = action.payload.inflow
        ? action.payload.inflow
        : action.payload.outflow;
    },
    getWidgetAnalyticsTransactionsGraphDataError: (state, action) => {
      state.loading = false;
      state.graphData = {};
    },
  },
});

export default analyticSlice;
